import React from 'react';
import "./index.scss";

const ReceiveCoupon: React.FC = () =>  {
  return(
    <div className='page'>
      <div>
      <img src={require("@/images/empty_coupon.png")} alt="失败" />
      </div>
      <div className='text'>恭喜您，卡券已成功领取至会员帐户</div>
    </div>
  )
};

export default ReceiveCoupon;